const _ = require('lodash');

module.exports.doesPropExistAndHasItChanged = (currentProps, nextProps, propString) => {
    const propValue = _.get(nextProps, propString);
    // apparently if the value is null we say it doesn't exist
    const doesExist = propValue !== undefined && propValue !== null;
    const isNotEqual = !_.isEqual(_.get(nextProps, propString), _.get(currentProps, propString));

    return doesExist && isNotEqual;
};